import Vue from "vue";
import App from "./App.vue";
import Loading from "./components/Loading";
import * as VueGoogleMaps from "vue2-google-maps";
import GmapCluster from "vue2-google-maps/dist/components/cluster";
import Axios from "axios";

Vue.config.productionTip = false;
Vue.component("GmapCluster", GmapCluster);

Vue.use(VueGoogleMaps, {
	load: {
		key: "AIzaSyDHXAflGXchb8Htcn9OCO86mu7ygx3PRDs",
		libraries: "places" // necessary for places input
	}
});
/* eslint no-console: 0 */
new Vue({
	render(h) {
		let comp = this.isReady ? App : Loading;

		return h(comp, {
			props: {
				schools: this.schools,
				filters: this.filters,
				words: this.words
			}
		});
	},
	data() {
		return {
			isReady: false,
			isError: false,
			schools: [],
			filters: [],
			words: [],
			endpoint: ""
		};
	},
	created() {
		this.endpoint = document
			.getElementById("app")
			.getAttribute("data-endpoint");
		Axios.get(this.endpoint)
			.then(response => {
				this.schools = response.data.schools;
				this.filters = response.data.filters;
				this.words = response.data.words;
				this.isReady = true;
			})
			.catch(() => {
				this.isError = true;
			});
	}
}).$mount("#app");
